import MainClass from '../utils/mainClass.ts';
import { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';

class Team extends MainClass {
	private bottomLine: HTMLElement;
	private tabs: HTMLElement[];
	private chips: HTMLElement[];
	private ourTeamSection: HTMLElement;
	private members: HTMLElement[];
	private chipsFilter: HTMLElement
	private chipSwiper: any;
	private clicking: Boolean;
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.tabs = Array.from( this.selector.querySelectorAll( '.tab-item' ) ) as HTMLElement[];
		this.bottomLine = this.selector.querySelector( '.tab-bottom-line' ) as HTMLElement;
		this.chips = Array.from( this.selector.querySelectorAll( '.raise-chip' ) ) as HTMLElement[];
		this.ourTeamSection = this.selector.querySelector( '.our-team-member' ) as HTMLElement;
		this.members = Array.from(this.selector.querySelectorAll('[data-call="MemberItem"]')) as HTMLElement[];
		this.chipsFilter = this.selector.querySelector('.raise-team-role-filter') as HTMLElement;
		this.chipSwiper = null
		this.clicking = false
		this.selector && this.init();
	}

	handleSameHeight(){
		if(window.matchMedia('(max-width: 767px)').matches && this.members.length > 0){
			let heightTemp = 0;
			this.members.forEach((item)=>{
				let getHeight = item.offsetHeight
				heightTemp < getHeight && (heightTemp = getHeight)
			})
			this.members.forEach((item )=>{
				item.style.height = `${heightTemp}px`
			})
		}
	}

	handleActiveTab( el: HTMLElement ) {
		this.tabs.forEach( ( item: HTMLElement ) => {
			item.classList.remove( 'active' );
			item.removeAttribute( 'style' );
		} );
		this.bottomLine.style.width = `${ el.offsetWidth }px`;
		this.bottomLine.style.left = `${ el.offsetLeft }px`;
		el.classList.add( 'active' );
		if (el.dataset.id === 'our-team') {
			this.chipsFilter.classList.add('active')
		} else {
			this.chipsFilter.classList.remove('active')
		}
	}

	handleClickTab = ( el: HTMLElement ) => {
		window.removeEventListener( 'scroll', this.handleScroll );
		this.handleActiveTab( el );
		setTimeout( () => {
			window.addEventListener( 'scroll', this.handleScroll );
		}, 700 );
	};

	handleClickTeamRole = ( el: HTMLElement ) => {
		const currentActive = this.selector.querySelector( '.raise-chip.active' ) as HTMLElement;
		if ( currentActive ) {
			currentActive.classList.remove( 'active' );
		}
		el.classList.add( 'active' );
	};
	addDivExpanded = ( cardMemberWrapper: HTMLElement, listEle: HTMLElement[] ) => {
		const numberItemPerRow = window
			.getComputedStyle( cardMemberWrapper )
			.getPropertyValue( 'grid-template-columns' )
			.split( ' ' ).length;
		listEle.forEach( ( _, index ) => {
			let lastItemIndex;
			let firstItemIndex;
			if ( ( index + 1 ) % numberItemPerRow === 0 ) {
				lastItemIndex = index;
				firstItemIndex = index - (numberItemPerRow -1)
			}
			if ( ( ( index + 1 ) % numberItemPerRow !== 0 && index + 1 === listEle.length ) || listEle.length == 1 ) {
				lastItemIndex = index;
				firstItemIndex = index
			}
			if ( lastItemIndex !== undefined && lastItemIndex?.toString() ) {
				const lastItemOfRow = listEle[ lastItemIndex ];
				const firstItemOfRow = listEle[ firstItemIndex ];
				if (firstItemOfRow) {
					firstItemOfRow.classList.add('darkExpandArrow')
				}
				const newDiv = document.createElement( 'div' );
				newDiv.className =
					'raise-member-expanded relative h-0 transition-all duration-300 overflow-hidden col-span-3 [&.active]:h-[400px] [&.active]:mt-5 [&.active]:mb-2';
				newDiv.setAttribute('generate',`time-${new Date().getTime()}`)
				lastItemOfRow.insertAdjacentElement( 'afterend', newDiv );
			}
		} );
	};
	handleScroll = () => {
		if ( this.ourTeamSection ) {
			const top = this.ourTeamSection.getBoundingClientRect().top;
			if ( top <= 130 && ! this.tabs?.[ 1 ].classList.contains( 'active' ) ) {
				this.handleActiveTab( this.tabs[ 1 ] );
				this.chipsFilter.classList.add('active')
			} else if ( top > 130 && ! this.tabs?.[ 0 ].classList.contains( 'active' ) ) {
				this.handleActiveTab( this.tabs[ 0 ] );
				this.chipsFilter.classList.remove('active')
			}
		}
	};
	handleAddExpandBlock = () => {
		if ( window.matchMedia( '(min-width: 600px)' ).matches ) {
			const memberCardWrapper = Array.from(
				this.selector.querySelectorAll( '.team-member-container' ),
			) as HTMLElement[];
			if ( memberCardWrapper.length ) {
				memberCardWrapper.forEach( item => {
					const memberCardItems = Array.from( item.querySelectorAll( '.raise-member' ) ) as HTMLElement[];
					this.addDivExpanded( item, memberCardItems );
				} );
			}
		}
	};
	handleShowHideOurTeamByChip = ( chip?: HTMLElement ) => {
		const ourTeamItems = Array.from( this.selector.querySelectorAll( '.our-team-item' ) ) as HTMLElement[];
		if ( ! chip ) {
			{
				this.chips[ 0 ].classList.add( 'active' );
				ourTeamItems.forEach( item => {
					if ( item.id === this.chips[ 0 ].dataset.slug ) {
						item.classList.add( 'active' );
					}
				} );
			}
		} else {
			const currentChipActive = this.selector.querySelector( '.raise-chip.active' ) as HTMLElement;
			const currentOurTeamActive = this.selector.querySelector( '.our-team-item.active' ) as HTMLElement;
			if ( currentChipActive ) {
				currentChipActive.classList.remove( 'active' );
			}
			if ( currentOurTeamActive ) {
				currentOurTeamActive.classList.remove( 'active' );
			}
			chip.classList.add( 'active' );
			ourTeamItems.forEach( item => {
				if ( item.id === chip.dataset.slug ) {
					item.classList.add( 'active' );
				}
			} );
		}
	};
	isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top - 176 >= 0 &&
			rect.bottom - 176 <= (window.innerHeight || document.documentElement.clientHeight)
		);
	}
	handleScrollChipSection(){
		let listChild = this.selector.querySelector('#our-team')?.children
		if(listChild && listChild.length > 1){
			let getSections = Array.from(listChild[1].querySelectorAll('&> *'))
			getSections.forEach((section,index)=>{
				window.addEventListener('scroll',()=>{
					if(this.isElementInViewport(section) && !this.clicking){
						this.chipSwiper.slideTo(index)
						this.handleClickTeamRole(this.selector.querySelector(`[data-slug="${section.getAttribute('id')}"]`))
						// this.chipSwiper.activeIndex = index
						if ( index === 0 || index === this.chipSwiper.slides.length - 1 ) {
							// this.chipSwiper.params.centeredSlides = false;
							this.chipSwiper.update();
						} else {
							// this.chipSwiper.params.centeredSlides = true;
							this.chipSwiper.update();
						}
					}
				})
			})
		}
	}

	init() {
		let header = document.querySelector('header')
		if ( this.tabs.length ) {
			this.tabs.forEach( ( item: HTMLElement ) => {
				item.addEventListener( 'click', () => this.handleClickTab( item ) );
				setTimeout( () => {
					item.classList.contains( 'active' ) && this.handleActiveTab( item );
				}, 200 );
			} );
		}
		if ( this.chips.length ) {
			this.chips.forEach( chip => {
				chip.addEventListener( 'click', () => this.handleShowHideOurTeamByChip( chip ) );
			} );
		}

		this.handleAddExpandBlock();

		const swiperInit = new Slider();
		this.chipSwiper = swiperInit.initCarousel(
			this.selector.querySelector( '.raise-chip-swiper' ) as HTMLElement,
			{
				slidesPerView: 1.2,
				spaceBetween: 12,
			},
		);

		// Handle center active slide
		this.chipSwiper.slides.forEach( ( slide, index ) => {
			slide.addEventListener( 'click', () => {
				let heightComponent = header.offsetHeight
				let heightChips = this.selector.querySelector( '.raise-chip-swiper' ).offsetHeight
				let getId = slide.getAttribute('data-slug')
				let getSection = document.querySelector(`#${getId}`)
				this.clicking = true
				this.chipSwiper.slideTo( index );
				this.chipSwiper.update();
				setTimeout(()=>{
					this.clicking = false
				},300)
				window.scroll({
					top:getSection.getBoundingClientRect().top + window.pageYOffset - heightComponent - heightChips - 20,
					behavior:"smooth"
				})
			} );
		} );

		if ( window.matchMedia( '(min-width: 600px)' ).matches ) {
			this.chipSwiper.disable();
			this.chipSwiper.destroy();
		}
		this.handleShowHideOurTeamByChip();
		const observer = new IntersectionObserver(
			( entries, observer ) => {
				entries.forEach( entry => {
					if ( entry.isIntersecting ) {
						window.addEventListener( 'scroll', this.handleScroll, { passive: true } );
					} else {
						window.removeEventListener( 'scroll', this.handleScroll );
					}
				} );
			},
			{
				root: null, // Viewport
				rootMargin: '0px', // Margin around the root
				threshold: 0.1, // Percentage of the element must be in view
			},
		);

		// Target the element to observe
		observer.observe( this.selector );
		this.handleScrollChipSection()
		this.handleSameHeight()
	}
}

export default Team;
